/* @flow */

import * as React from 'react';

export default function useTrackAbandons() {
  React.useEffect(() => {
    // Stop listening for load abandonment
    document.removeEventListener('visibilitychange', window.__trackAbandons);
  }, []);
}
